/** Détection iOS (même heuristique que usePwaInstallPromptModal.tsx) pour du code hors React. */
export function isIOSDevice(ua: string = (typeof navigator !== 'undefined' ? navigator.userAgent : '')): boolean {
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && typeof document !== 'undefined' && 'ontouchend' in document);
}
